<template>
  <div class="header">
    <v-toolbar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="blue darken-3"
      dark
      app
      fixed
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <router-link :to="{ name: 'Home' }" class="white--text no--underline">Aaron Farr</router-link>
      </v-toolbar-title>
      <Search />
      <v-spacer></v-spacer>
      <div v-if="user">
        <v-btn icon>
          <v-icon>verified_user</v-icon>
        </v-btn>
        {{ user.email }}
        <!-- <v-btn flat @click="logout()">
          Logout
        </v-btn> -->
        <v-btn icon large @click="logout()">
          <v-avatar size="32px">
            <img
              :src="gravatar"
              :alt="user.email"
            >
          </v-avatar>
        </v-btn>
      </div>
      <div v-else>
        <v-btn flat @click="go('Login')">Login</v-btn>
      </div>
      
    </v-toolbar>
    <v-toolbar color="white" tabs>
      <v-spacer></v-spacer>
      <v-tabs
        slot="extension"
        v-model="tab"
        align-with-title
        v-if="this.$route.name=='Home'"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item.name" v-on:click="filter(item.type)">
          {{ item.name }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
  </div>
</template>

<script>
import Search from '@/components/Search'
import firebase from 'firebase'
import crypto from 'crypto-js'
export default {
  name: 'Header',
  data() {
    return {
      user: null,
      gravatar: '',
      tab: null,
      items: [
        {name: 'All', type: ''},
        {name: 'Apps', type: 'app'},
        {name: 'Articles', type: 'article'},
        {name: 'Audio', type: 'audio'},
        {name: 'Videos', type: 'video'},
        {name: 'Resources', type: 'resource'}
      ],
      items2: [
        {name: 'All', type: ''},
        {name: 'Optimization', type: 'optimization'},
        // {name: 'Artificial Intelligence', type: 'artificial-intelligence'},
        // {name: 'Game Development', type: 'game-development'},
        // {name: 'Martial Arts', type: 'martial-arts'},
        // {name: 'Fatherhood', type: 'fatherhood'},
      ]
    }
  },
  components: {
    Search
  },
  methods: {
    filter(type) {
      this.$store.commit('FILTER_BY_TYPE', type)
    },
    go( routeName ) {
      this.$router.push({ name: routeName })
    },
    logout() {
      firebase.auth().signOut().then( () => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  created() {
    firebase.auth().onAuthStateChanged( user => {
      if( user ) {
        this.user = user
        this.gravatar = 'https://www.gravatar.com/avatar/' + 
          crypto.MD5(user.email).toString()
      } else {
        this.user = null
      }
    })
  }
}
</script>

<style>
  .no--underline {
    text-decoration: none;
  }
</style>
